module.exports = __webpack_public_path__ + "static/media/lena.6ddb6ff5.png";